import axios from 'axios';
import Cookies from 'js-cookie';

const BASE_URL_BE = process.env.REACT_APP_BASE_URL_BE;

const getAuthToken = () => Cookies.get('access_token');

const getAuthHeaders = () => ({
  'Authorization': `Bearer ${getAuthToken()}`
});

export const fetchJenisSoal = async (page = 1, per_page = 10, filters = {}) => {
  try {
    const params = new URLSearchParams({
      page,
      per_page,
      ...(filters.jenis_seleksi && { jenis_seleksi: filters.jenis_seleksi }),
    });

    const response = await axios.get(`${BASE_URL_BE}/jenis_soal?${params.toString()}`, {
      headers: getAuthHeaders()
    });
    
    // Hitung last_page jika tidak disediakan oleh backend
    const meta = response.data.meta || {};
    const last_page = Math.ceil(meta.total / meta.per_page) || 1;
    
    return {
      data: response.data.data || [],
      meta: {
        page: meta.page || page,
        per_page: meta.per_page || per_page,
        total: meta.total || 0,
        last_page: last_page
      }
    };
  } catch (error) {
    console.error("Error fetching jenis soal:", error);
    throw error;
  }
};

export const createJenisSoal = async (formData) => {
  try {
    const response = await axios.post(`${BASE_URL_BE}/jenis_soal`, formData, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error creating paket:", error);
    throw error;
  }
};

export const updateJenisSoal = async (id_jenis_soal, formData) => {
  try {
    const response = await axios.put(`${BASE_URL_BE}/jenis_soal/${id_jenis_soal}`, formData, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error updating paket:", error);
    throw error;
  }
};

export const deleteJenisSoal = async (id) => {
  try {
    const response = await axios.delete(`${BASE_URL_BE}/jenis_soal/${id}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting paket:", error);
    throw error;
  }
};



export const listJenisSoal = async (jenisSeleksi) => {
  try {
    const response = await axios.get(`${BASE_URL_BE}/jenis_soal/list`, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'multipart/form-data'
      },
      params: {
        jenis_seleksi: jenisSeleksi
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error updating paket:", error);
    throw error;
  }
};






